// cfgactions

import http from '../../../store/api/http' 

const actions = {
    getCfgActions(context, param) {
		return new Promise((resolve, reject) => {
			http.get('/api/cfgactions')
			.then(function (response) {
		    	context.commit('getCfgActions', response.data)
				resolve(response)
			})
			.catch(function (error) {
				console.log(error)
				reject(error)
			});
		})
    },
    updateCfgActions(context, data) {
		return new Promise((resolve, reject) => {
			http.post('/api/cfgactions', data)
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				console.log(error)
				reject(error)
			});
		})
    },

};

export default actions;